import React from 'react';

import { Box, Button, Flex, Text } from '@rover/kibble/core';

import {
  BUTTON_SIZE_TO_BADGE_SIZE_MAP,
  ButtonWithCountBadgeWebProps,
} from './ButtonWithCountBadge.common';

const ButtonWithCountBadge = ({
  badgeCount,
  ariaLabel,
  badgeTestID,
  // Consumed here so it is not spread onto the DOM Button. Native-only behavior.
  hideBadgeFromScreenReader: _hideBadgeFromScreenReader, // eslint-disable-line @typescript-eslint/no-unused-vars
  onClick,
  size = 'default',
  ...otherProps
}: ButtonWithCountBadgeWebProps): JSX.Element => {
  const badgeSize = BUTTON_SIZE_TO_BADGE_SIZE_MAP[size];

  return (
    <Flex alignItems="center">
      <Box position="relative">
        {badgeCount ? (
          <Box
            data-testid={badgeTestID}
            background="attention_highlight"
            borderRadius="round"
            justifyContent="center"
            alignItems="center"
            width={badgeSize}
            height={badgeSize}
            sx={{
              position: 'absolute',
              top: -6,
              right: -4,
              zIndex: 1,
              display: 'flex',
            }}
          >
            <Text
              size="50"
              fontWeight="semibold"
              textAlign="center"
              sx={{
                textAlignVertical: 'center',
                lineHeight: `${badgeSize}px`,
                width: '100%',
              }}
            >
              {badgeCount}
            </Text>
          </Box>
        ) : null}
        <Button onClick={onClick} size={size} aria-label={ariaLabel} {...otherProps} />
      </Box>
    </Flex>
  );
};

export default ButtonWithCountBadge;
